/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";

  $(document).on('click', '.nav-toggle-mobile', function (e) {
    $('html').addClass('mobile-nav-on');
  });
  $(document).on('click', '.nav-close-mbile', function (e) {
    $('html').removeClass('mobile-nav-on');
  });
  $(document).on('click', '.nav-toggle-da', function (e) {
    $('html').addClass('da-nav-on');
    $('body').addClass('da-menu-item-1');
    $('.direcy-accessibility-menu').addClass('da-nav-open');
  });
  $(document).on('click', '.nav-close-da', function (e) {
    $('html').removeClass('da-nav-on');
    $('.direcy-accessibility-menu').removeClass('da-nav-open');
  });
  $(document).on('click', '.quick-menu', function (e) {
    $('html').addClass('da-nav-on');
    $('.direcy-accessibility-menu').removeClass('da-nav-open');
    $('.direcy-accessibility-menu-tab li').removeClass('active');
    $('.direcy-accessibility-menu-item').removeClass('nav-active');
    $('html').removeClass('mobile-nav-on');
    /*setTimeout(function(){ 
      $('html').removeClass('mobile-nav-on');
    }, 1000);*/
  });


  $('.popup-with-form').magnificPopup({
    type: 'inline',
    preloader: false,

    // When elemened is focused, some mobile browsers in some cases zoom in
    // It looks not nice, so we disable it:
    callbacks: {
      beforeOpen: function () {
        if ($(window).width() < 700) {
          this.st.focus = false;
        } else {
          this.st.focus = '#name';
        }
      }
    }
  });


  $('.image-popup').magnificPopup({
    type: 'image',
    gallery: {
      enabled: true
    }
  });
  $('.video-popup').magnificPopup({
    type: 'iframe',
    iframe: {
      markup: '<div class="mfp-iframe-scaler">' +
        '<div class="mfp-close"></div>' +
        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
        '</div>',
      patterns: {
        youtube: {
          index: 'youtube.com/',
          id: 'v=',
          src: '//www.youtube.com/embed/%id%?autoplay=1'
        }
      },
      srcAction: 'iframe_src',
    },
    callbacks: {
      open: function (el) {
        $('html').addClass('mfp-cs-open');
      },
    }
  });

  $('.our-expedtition-cl').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 8,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 5000,
    prevArrow: '<button type="button" class="slick-next"><i class="icon-arrow-right"></i></button>',
    nextArrow: '<button type="button" class="slick-prev"><i class="icon-arrow-left"></i></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          variableWidth: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          variableWidth: true,
        }
      },
    ]
  });
  $('.our-clients-cl').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: true,
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 2500,
    nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow-right"></i></button>',
    prevArrow: '<button type="button" class="slick-prev"><i class="icon-arrow-left"></i></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
        }
      },
    ]
  });
  $('.about-testimonials-cl').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          autoplay: false
        }
      }
    ]
  });


  var project_phases = document.querySelector('.project-phase-cl');
  if (project_phases != null) {
    $('.project-phase-cl').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      prevArrow: "<button class='slick-prev'><span class='icon icon-arrow-right'></span></button>",
      nextArrow: "<button class='slick-next'><span class='icon icon-arrow-right'></span></button>",
      responsive: [
        {
          breakpoint: 640,
          settings: "unslick"
        }
      ]
    });
  }

  var bespoke_solutions_slider = document.querySelector('.bespoke_solutions_slider');
  if (bespoke_solutions_slider != null) {
    $('.bespoke_solutions_slider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      speed: 250,
      pauseOnHover: true,
      autoplaySpeed: 2000,
      prevArrow: "<button class='slick-prev'><span class='icon icon-arrow-right'></span></button>",
      nextArrow: "<button class='slick-next'><span class='icon icon-arrow-right'></span></button>",
      responsive: [
        {
          breakpoint: 640,
          settings: "unslick"
        }
      ]
    });
  }



  $(window).on('scroll', function (e) {
    var ST = $(this).scrollTop();
    /*if(ST >= 50){
      $('.site-header').addClass('floating color-change');
    }else{
      $('.site-header').removeClass('floating color-change');
    }*/
    if ($('.floating-sub-nav').length) {
      var OT = $('.why-us-content').offset().top;
      var HH = $('.site-header.floating').outerHeight();
      var TopPos = OT + 45;
      if (ST >= TopPos) {
        $('.floating-sub-nav').addClass('static');
      } else {
        $('.floating-sub-nav').removeClass('static');
      }
    }
  });
  //custom scroll spy

  var lastId,
    topMenu = $(".floating-sub-nav"),
    topMenuHeight = topMenu.outerHeight(),
    menuItems = topMenu.find("a"),
    mainMenuHeight = $('.site-header.floating').outerHeight(),
    scrollItems = menuItems.map(function () {
      var item = $($(this).attr("href"));
      if (item.length) { return item; }
    });

  menuItems.click(function (e) {
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1;
    $('html, body').stop().animate({
      scrollTop: offsetTop
    }, 300);
    e.preventDefault();
  });

  $(window).scroll(function () {
    // Get container scroll position
    var fromTop = $(this).scrollTop() + topMenuHeight + 60;

    var cur = scrollItems.map(function () {
      if ($(this).offset().top < fromTop)
        return this;
    });
    cur = cur[cur.length - 1];
    var id = cur && cur.length ? cur[0].id : "";

    if (lastId !== id) {
      lastId = id;
      menuItems
        .parent().removeClass("active")
        .end().filter("[href='#" + id + "']").parent().addClass("active");
    }
  });
  AOS.init({
    easing: 'ease-in-out-sine',
    duration: 400
  });
  $(".changepane").click(function (e) {
    var pane = $(this).data('pane');
    var item = $(this).data('item');
    e.preventDefault();
    $('.compareitem-' + pane).addClass('d-none');
    $('.pane-' + pane + '-' + item).removeClass('d-none');
  });
  $(document).on("click", ".scroll-to", function (e) {
    var href = $(this).attr("href");
    var offsetTop = href === "#" ? 0 : $(href).offset().top;
    var HdTop = $(".site-header").outerHeight();
    $("html, body").stop().animate({
      scrollTop: offsetTop
    }, 500);
    e.preventDefault();
  });


  // Hide Header on on scroll down
  var didScroll;
  var lastScrollTop = 0;
  var delta = 4;
  var navbarHeight = $('.site-header').outerHeight();

  $(window).on('scroll', function (event) {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $(window).scrollTop();
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta)
      return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $('.site-header').removeClass('nav-down').addClass('nav-up');
      $('.floating-sub-nav').removeClass('header-up');
      $('body').removeClass('nav-active');
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height() && st > navbarHeight) {
        $('.site-header').removeClass('nav-up').addClass('nav-down color-change');
        $('body').addClass('nav-active');
        $('.floating-sub-nav').addClass('header-up');
      }
    }
    if (st >= 200) {
      $('.site-header').addClass('nav-hiding');
    } else {
      $('.site-header').removeClass('nav-hiding');
    }
    if (st < delta) {
      $('.site-header').removeClass('nav-up nav-down color-change');
      $('body').removeClass('nav-active');
      $('.floating-sub-nav').removeClass('header-up');
    }

    lastScrollTop = st;

  }
  /*--- DA menu tab ---*/
  $('.direcy-accessibility-menu-tab li').each(function () {
    $(this).on('mouseover', function () {
      $('body').removeClass('da-menu-item-1');
      if (($(this).index() == 0)) {
        $('body').addClass('da-menu-item-1');
      }
    });
  });
  $('.direcy-accessibility-menu-item:first-child').addClass('nav-active');
  $('.direcy-accessibility-menu-tab li:first-child').addClass('active');
  $(document).on('mouseover', '.direcy-accessibility-menu-tab li a', function () {
    $('.direcy-accessibility-menu-tab li').removeClass('active');
    $(this).parent().addClass('active');
    var currentTab = $(this).attr('href');
    var index = $(this).parent().index();
    $('div.direcy-accessibility-menu-item').removeClass('nav-active');
    //$(currentTab).addClass('nav-active');
    $('div.direcy-accessibility-menu-item').eq(index).addClass('nav-active');
    $('.direcy-accessibility-menu').addClass('da-nav-open');
    return false;
  });
  $(document).on('click', '.nav-back', function () {
    $('.direcy-accessibility-menu-tab li').removeClass('active');
    $('div.direcy-accessibility-menu-item').removeClass('nav-active');
    $('.direcy-accessibility-menu').removeClass('da-nav-open');
    return false;
  });
  $(document).on('mouseover', '.direcy-accessibility-menu-item ul .tab-item-content li.menu-item-has-children > a', function (e) {
    e.preventDefault();
    $('.direcy-accessibility-menu-item ul .tab-item-content li.menu-item-has-children').removeClass('active');
    $(this).parent().addClass('active');
    $('.direcy-accessibility-menu-item ul .tab-item-content li.menu-item-has-children .sub-menu').hide();
    $(this).next().show();

  });
  $(document).on('mouseover', '.direcy-accessibility-menu-item ul.menu > li.menu-item-has-children:not(.tab-item) > a', function (e) {
    e.preventDefault();
    $('.direcy-accessibility-menu-item ul.menu > li.menu-item-has-children:not(.tab-item)').removeClass('active');
    $(this).parent().addClass('active');
    $('.direcy-accessibility-menu-item ul.menu > li.menu-item-has-children:not(.tab-item) > .sub-menu').hide();
    $(this).next().show();

  });
  $('.direcy-accessibility-menu-item li.tab-item a').eq(0).addClass('active');
  $('.direcy-accessibility-menu-item li.tab-item-content').eq(0).show();
  $('.direcy-accessibility-menu-item li.tab-item-content').eq(0).find('.sub-menu > li:first-child').addClass('active');
  $('.direcy-accessibility-menu-item li.tab-item-content').eq(0).find('.sub-menu > li:first-child > .sub-menu').show();
  $(document).on('mouseover', '.direcy-accessibility-menu-item li.tab-item > a', function (e) {
    e.preventDefault();
    var totalCount = $(this).parent().parent().find('>li').length;
    var index = $(this).parent().index();
    $('.direcy-accessibility-menu-item li.tab-item-content').hide();
    $('.direcy-accessibility-menu-item li.tab-item-content').eq(index).show();
    $('.direcy-accessibility-menu-item li.tab-item > a').removeClass('active');
    $(this).addClass('active');
  });
  $(document).on('click', '.career-section-item-foot', function (e) {
    e.preventDefault();
    $(this).parent().toggleClass('on');
    $(this).parent().find('.career-section-item-content').slideToggle();
  });
  $(document).on('click', '.map-marker', function (e) {
    e.preventDefault();
  });
  $(document).on('click', '.career-section-head-right a', function (e) {
    e.preventDefault();
    var $el = $(this),
      link = $el.attr('href'),
      text = $el.text();
    if ($el.attr('disabled'))
      return;
    $(this).parents('.dropdown').find('span').html(text);
    $('#careers').addClass('loading');
    $("#career-items").load(link, function () {
      $('#careers').removeClass('loading');
    });
  });
  $(document).on('click', '.direcy-accessibility-menu-item li:not(.menu-item-has-children, .tab-item) > a', function (e) {
    var pageURL = $(location).attr("href");
    var href = $(this).attr("href");
    var newURL = window.location.href.split('#')[0];
    if (pageURL.includes(newURL)) {
      $('html').removeClass('da-nav-on');
      $('.direcy-accessibility-menu').removeClass('da-nav-open');
    }
  });
});


// Tab Javascript
(function ($) {
  $.organicTabs = function (el, options) {
    var base = this;
    base.$el = $(el);
    base.$nav = base.$el.find(".tab-nav");

    base.init = function () {

      base.options = $.extend({}, $.organicTabs.defaultOptions, options);

      $(".hide").css({
        "position": "relative",
        "top": 0,
        "left": 0,
        "display": "none"
      });

      base.$nav.delegate("a", "click", function (e) {

        e.preventDefault();

        var curList = base.$el.find("a.current").attr("href").substring(1),

          $newList = $(this),

          listID = $newList.attr("href").substring(1),

          $allListWrap = base.$el.find(".tab-content"),
          curListHeight = $allListWrap.height();
        $allListWrap.height(curListHeight);

        if ((listID != curList) && (base.$el.find(":animated").length == 0)) {

          base.$el.find("#" + curList).fadeOut(base.options.speed, function () {

            base.$el.find("#" + listID).fadeIn(base.options.speed);

            var newHeight = base.$el.find("#" + listID).height();
            $allListWrap.animate({
              height: newHeight
            }, base.options.speed);

            base.$el.find(".tab-nav li a").removeClass("current");
            $newList.addClass("current");

            if (window.history && history.pushState) {
              history.replaceState("", "", "?" + base.options.param + "=" + listID);
            }
          });

        }

      });

      var queryString = {};
      window.location.href.replace(
        new RegExp("([^?=&]+)(=([^&]*))?", "g"),
        function ($0, $1, $2, $3) { queryString[$1] = $3; }
      );

      if (queryString[base.options.param]) {

        var tab = $("a[href='#" + queryString[base.options.param] + "']");

        tab
          .closest(".tab-nav")
          .find("a")
          .removeClass("current")
          .end()
          .next(".tab-content")
          .find(".tab-content-item")
          .hide();
        tab.addClass("current");
        $("#" + queryString[base.options.param]).show();
        jQuery('html, body').animate({
          scrollTop: jQuery('#integrations').offset().top - 70
        }, 900, 'swing');

      };

    };
    base.init();
  };

  $.organicTabs.defaultOptions = {
    "speed": 300,
    "param": "tab"
  };

  $.fn.organicTabs = function (options) {
    return this.each(function () {
      (new $.organicTabs(this, options));
    });
  };

  // Compare table
  $('.option-sap-business-bydesign').on('click', function () {
    $('.compare-column-2-options a').each(function () {
      // if (!$(this).hasClass('option-oracle-netsuite') && !$(this).hasClass('option-microsoft-dynamics')) {
      //   $(this).hide();
      // }
    });

    // $('.compareitem-right').addClass('d-none');
    // $('.pane-right-3').removeClass('d-none');

  });
  $('.option-sap-business-one').on('click', function () {
    $('.compare-column-2-options a').each(function () {
      $(this).show();
    });
  });

  $("a[href*='#']:not([href='#'])").click(function (e) {
    var hash = this.hash;
    var section = $(hash);
    if (!$(this).hasClass("popup-with-form")) {
      if (hash) {
        $('html, body').animate({
          scrollTop: section.offset().top - 70
        }, 1000, 'swing', function () {
          history.replaceState({}, "", hash);
        });
      }
    }
  });

})(jQuery);


// Avaniko Solutions - Integreations Tab
jQuery(function () {
  jQuery("#integrations-tab").organicTabs({
    "speed": 100,
    "param": "integration"
  });
  jQuery("#functionalities-tab").organicTabs({
    "speed": 100,
    "param": "functionality"
  });

});




